export const globalTransition = {
  duration: 0.8, // Set your global duration here
  delay: 0.3,
};
